import { createFileRoute } from "@tanstack/react-router";
import { BrandingCreativesServicePage } from "./services_.branding-creatives";

export const Route = createFileRoute("/services_/branding-creatives-and-brand-strategy-services")({
  head: () => ({
    meta: [
      {
        title: "Branding & Strategy Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Brand Strategy, Positioning & Creative Ecosystems.",
      },
    ],
  }),
  component: BrandingCreativesServicePage,
});
